import { useState } from 'react'
import './Reporting.scss'
import { Button } from '../../Components/Button/Button'
import { useLocalization } from '../../Hooks/useLocalization'
import { CertTypesPerInstitution } from './CertTypesPerInstitution/CertTypesPerInstitution'
import { ObsoleteCertificateNaceCodes } from './ObsoleteCertificateNaceCodes/ObsoleteCertificateNaceCodes'

export function Reporting() {
  const [activeReport, setActiveReport] = useState<
    'cert-type-per-institution' | 'obsolete-certificate-nace-codes' | undefined
  >()
  const localization = useLocalization('reporting')

  return (
    <div className="reporting">
      <div className="button-row">
        <Button
          importance="secondary"
          text={localization.text(
            'certificate-types-per-institution-button',
            'Certificaat types per instelling'
          )}
          onClick={() => {
            setActiveReport('cert-type-per-institution')
          }}
        />
        <Button
          importance="secondary"
          text={localization.text(
            'obsolete-certificate-nace-codes-button',
            'Certificaten met vervallen nace codes'
          )}
          onClick={() => {
            setActiveReport('obsolete-certificate-nace-codes')
          }}
        />
      </div>
      <div className="report-wrapper">
        {activeReport === 'cert-type-per-institution' ? (
          <CertTypesPerInstitution />
        ) : activeReport === 'obsolete-certificate-nace-codes' ? (
          <ObsoleteCertificateNaceCodes />
        ) : null}
      </div>
    </div>
  )
}
